import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import classNames from 'classnames';
import get from 'lodash/get.js';
import CirclePlusFilled from 'dibs-icons/exports/legacy/CirclePlusFilled.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

import styles from './styles/CreatorsGroup.scss';

const UNFOLDED_ITEMS_PER_GROUP = 21;

class CreatorsGroupComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }
    toggleExpand(e) {
        e.preventDefault();
        const { onLetterSelect } = this.props;
        const groupName = get(this.props, 'creatorGroup.groupName') || '';
        onLetterSelect(groupName.toLowerCase());
        this.setState(state => ({ isExpanded: !state.isExpanded }));
    }
    shouldHideItem(index) {
        return index > UNFOLDED_ITEMS_PER_GROUP - 1 && !this.state.isExpanded;
    }
    render() {
        const { isExpanded } = this.state;
        const groupName = get(this.props, 'creatorGroup.groupName') || '';
        const creatorsList = get(this.props, 'creatorGroup.creators') || [];
        const creatorsCount = creatorsList.length;
        const canExpand = creatorsCount > UNFOLDED_ITEMS_PER_GROUP;

        return (
            <div id={groupName.toLowerCase()} className={styles.wrapper}>
                <div className={styles.header}>
                    <div className={styles.letter}>{groupName}</div>
                    <div
                        className={classNames(styles.seeAll, { [styles.canExpand]: canExpand })}
                        onClick={canExpand ? this.toggleExpand : null}
                    >
                        <span className={styles.countLink}>
                            <FormattedMessage
                                id="CreatorsGroup.creatorCount"
                                defaultMessage="{creatorsCount, plural, one {# Creator} other {# Creators}}"
                                values={{ creatorsCount }}
                            />
                        </span>
                        <span className={styles.divider}>/</span>
                        <a className={styles.seeAllLink}>
                            {isExpanded ? (
                                <FormattedMessage
                                    id="CreatorsGroup.seeLess"
                                    defaultMessage="See Less"
                                />
                            ) : (
                                <FormattedMessage
                                    id="CreatorsGroup.seeAll"
                                    defaultMessage="See All"
                                />
                            )}
                        </a>
                        <CirclePlusFilled className={styles.plusIcon} />
                    </div>
                </div>
                <div className={styles.listWrapper}>
                    <ul className={styles.list}>
                        {creatorsList.map((creator, index) => (
                            <li
                                key={creator.url}
                                className={
                                    this.shouldHideItem(index) ? styles.hidden : styles.listItem
                                }
                            >
                                <Link className={styles.link} href={creator.url}>
                                    {creator.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    {canExpand && (
                        <ul className={`${styles.list} ${styles.moreLessList}`}>
                            <li className={styles.listItem}>
                                <a
                                    onClick={canExpand ? this.toggleExpand : null}
                                    className={`${styles.moreLessLink} ${styles.moreLess}`}
                                    href="#"
                                >
                                    {isExpanded ? (
                                        <FormattedMessage
                                            id="CreatorsGroup.less"
                                            defaultMessage="Less"
                                        />
                                    ) : (
                                        <FormattedMessage
                                            id="CreatorsGroup.more"
                                            defaultMessage="More"
                                        />
                                    )}
                                </a>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}

CreatorsGroupComponent.propTypes = {
    creatorGroup: PropTypes.object.isRequired,
    onLetterSelect: PropTypes.func.isRequired,
};

export const CreatorsGroup = createFragmentContainer(CreatorsGroupComponent, {
    creatorGroup: graphql`
        fragment CreatorsGroup_creatorGroup on CreatorGroup {
            groupName
            creators {
                url(vertical: $vertical)
                name
            }
        }
    `,
});
